import { getApiConfig } from '@/api/config/client/getApiConfig';
import { getUiConfig } from '@/config/client/getUiConfig';

const apiConfig = getApiConfig();
const uiConfig = getUiConfig();

/**
 * Configuration options for the Profile SDK both server-side and client-side.
 * Without statefulRefreshToken
 */
export const configOptions: Foxkit.ConfigOptions = {
  apiKey: apiConfig.apiKey,
  appName: uiConfig.appName,
  appVersion: uiConfig.appVersion,

  isSsr: true,

  // statefulRefreshToken will be set in each server-side and client-side configs
};
